import { createUseStyles } from "react-jss";

const styles = createUseStyles({
  //
});

export default styles;